module.exports = __webpack_public_path__ + "img/cadastro.6a21f8d9.svg";